import "./tarifsNavButton.css";

import { motion } from "framer-motion";

import UseTarifsMainColor from "../../../hooks/UseTarifsMainColor";
import UseSelectedTarifID from "../../../hooks/UseSelectedTarifsID";
import UseTarifsSecondColor from "../../../hooks/UseTarifsSecondColor";
import TarifsButtonToken from "../../../hooks/TarifsButtonToken";
import UseTarifRibbonColor from "../../../hooks/UseTarifsRibbonColor";

function TarifsNavButton({ children, id, first = false, last = false }) {
  const mainColor = UseTarifsMainColor((state) => state.color);
  const ribbonColor = UseTarifRibbonColor((state) => state.color);

  const secondColor = UseTarifsSecondColor((state) => state.color);
  const setMainColor = UseTarifsMainColor((state) => state.setColor);
  const setSecondColor = UseTarifsSecondColor((state) => state.setColor);
  const setRibbonColor = UseTarifRibbonColor((state) => state.setColor);

  const animating = TarifsButtonToken((state) => state.token);
  const setAnimating = TarifsButtonToken((state) => state.setToken);

  const setSelectedTarifID = UseSelectedTarifID(
    (state) => state.setSelectedTarifID
  );
  const selectedTarifID = UseSelectedTarifID((state) => state.value);

  const color = selectedTarifID !== id ? secondColor : mainColor;

  return (
    <div className="tarifs-nav-button-container">
      <div
        className="tarifs-nav-button-filter"
        style={{
          top: first ? "4px" : "2px",
          height: first || last ? "calc(100% - 6px)" : "calc(100% - 4px)",
          width:
            selectedTarifID === id ? "calc(100% - 2px)" : "calc(100% - 6px)",
          left: selectedTarifID === id ? "0px" : "4px",
          zIndex: selectedTarifID !== id ? 1 : 0,
          backgroundColor: selectedTarifID !== id ? "#00000000" : "#00000015",
        }}
      ></div>
      <motion.div
        className="tarifs-nav-button"
        onClick={() =>
          SwapColors(
            mainColor,
            ribbonColor,
            secondColor,
            setMainColor,
            setSecondColor,
            setRibbonColor,
            animating,
            setAnimating,
            setSelectedTarifID,
            selectedTarifID,
            id
          )
        }
        style={{
          borderCollapse: "collapse",
          borderTop: first ? "4px solid #222223" : "2px solid #222223",
          borderBottom: last ? "4px solid #222223" : "2px solid #222223",
          zIndex: selectedTarifID !== id ? 1 : 0,
        }}
        animate={{
          textAlign: selectedTarifID === id ? "left" : "center",
          justifyContent: selectedTarifID === id ? "left" : "center",
          backgroundColor: color,
          borderLeft: selectedTarifID === id ? `4px` : "4px solid #222223",
        }}
        transition={{ duration: 0.5 }}
      >
        {children}
      </motion.div>
    </div>
  );
}

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

async function SwapColors(
  mainColor,
  ribbonColor,
  secondColor,
  setMainColor,
  setSecondColor,
  setRibbonColor,
  animating,
  setAnimating,
  setSelectedTarifID,
  selectedTarifID,
  id
) {
  if (!animating && id !== selectedTarifID) {
    setAnimating(true);

    const temp = mainColor;
    setMainColor(secondColor);
    setRibbonColor(secondColor);
    await sleep(700);
    setSelectedTarifID(id);

    setMainColor(temp);
    setRibbonColor(secondColor + "00");
    await sleep(500);

    setAnimating(false);
  }
}

export default TarifsNavButton;
